import * as URLConfig from "@frameworks/web/config/domain";
import { urlConstructor } from "@frameworks/web/config/domain";
var config = URLConfig.config;
var bookmark = "bookmark";
var bookmarksConfigURL = {
    saveBookmarks: urlConstructor(config.app_mf, bookmark, "/save"),
    // saveBookmarks: config.jmw + config.app_mf + bookmark + "/save",
    fetchBookmarks: urlConstructor(config.app_mf, bookmark, "/fetch"),
    // fetchBookmarks: config.jmw + config.app_mf + bookmark + "/fetch",
    deleteBookmarks: urlConstructor(config.app_mf, bookmark),
    // deleteBookmarks: config.jmw + config.app_mf + bookmark,
    filtersBookmarks: urlConstructor(config.app_mf, bookmark, "/filter"),
    // filtersBookmarks: config.jmw + config.app_mf + bookmark + "/filter",
};
export default bookmarksConfigURL;
